var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var InputMask = function () {
            function InputMask() {
                _classCallCheck(this, InputMask);

                this.handlers();
            }

            _createClass(InputMask, [{
                key: "handlers",
                value: function handlers() {
                    var items = document.querySelectorAll('.js-input-mask');

                    if (items) {
                        items.forEach(function (item) {
                            IMask(item, {
                                mask: item.dataset.mask,
                                definitions: {
                                    X: {
                                        mask: '0',
                                        displayChar: 'X',
                                        placeholderChar: '#'
                                    }
                                },
                                lazy: false,
                                overwrite: 'shift'
                            });
                        });
                    }
                }
            }]);

            return InputMask;
        }();

        module.exports = InputMask;

        new InputMask();
    }, {}] }, {}, [1]);